import { CustomerProfileEligibleAccountsPermissions } from './customer-management.customer-profiles.eligible-accounts.permissions';
import { CustomerProfileOrdersPermissions } from './customer-management.customer-profiles.orders.permissions';
import { CustomerProfilesPermissions } from './customer-management.customer-profiles.permissions';
import { CustomerProfileVehiclesPermissions } from './customer-management.customer-profiles.vehicles.permissions';

export class CustomerManagementPermissions {
  static CustomerProfiles = CustomerProfilesPermissions?.Permissions;
  static CustomerProfileEligibleAccounts = CustomerProfileEligibleAccountsPermissions?.Permissions;
  static CustomerProfileVehicles = CustomerProfileVehiclesPermissions?.Permissions;
  static CustomerProfileOrders = CustomerProfileOrdersPermissions?.Permissions;
}

export function getCustomerManagementModuleName() {
  return 'CustomerManagement';
}
